import { create } from 'zustand'
import { devtools, persist } from 'zustand/middleware'
import type { ICart } from '~/schemas/cart/cart'

interface ICartState {
    /** Carrinho aberto como a API devolve (`CartSchema`), ou null quando não há carrinho aberto. */
    data: ICart | null
    /** Grava o carrinho tipado (hooks de `hooks/business/cart`). `null`: a sessão não tem carrinho aberto. */
    setCart: (cart: ICart | null) => void
    resetStore: () => void
}

const initialState = {
    data: null as ICart | null,
}

// Chave de persist de sempre (cart-storage): ninguém perde o carrinho na troca. Só o carrinho é gravado e lido: os campos
// antigos shippingValue, zipCodeValue e CEP, sem leitor, saíram (o CEP do visitante fica na useZipCodeStore) e são
// ignorados na reidratação. O cache reidratado não passa pelo schema (um carrinho gravado por versão antiga continua
// aparecendo); o `useCart` o troca pelo `cart/current` ao montar.
export const useCartStore = create<ICartState>()(
    devtools(
        persist(
            (set) => ({
                ...initialState,
                setCart: (cart) => set({ data: cart }, false, 'setCart'),
                resetStore: () => set(initialState, false, 'resetStore'),
            }),
            {
                name: 'cart-storage',
                partialize: (state) => ({ data: state.data }),
                merge: (persisted, current) => ({
                    ...current,
                    data: (persisted as { data?: ICart | null } | null)?.data ?? null,
                }),
            },
        ),
        { name: 'cart-store' },
    ),
)
